<template>
  <div class="task_page-new" id="task_answer">
    <!--<span class="task_answer_span"></span>-->
    <div class="task_main" ref="middle_page">
      <div class="taskPage">
        <div class="primarylists list-mobile">
          <div class="titles clear">
            <img src="../../../static/images/icon-st.jpg" alt="" />
            <span
              v-if="outlineInfo.type != '0'"
              class="title l"
              @click="goto_lesson"
              >{{ outlineInfo.courseName }}</span
            >
            <span
              v-if="outlineInfo.type == '0'"
              class="title l"
              @click="goto_lesson"
              >{{ outlineInfo.secondChapterName }}</span
            >
            <p>
              <span class="title l">{{ homeWorkName }}</span>
            </p>
          </div>
        </div>
        <div class="div-btn-icon">
          <!-- != 0 -->
          <button
            v-if="outlineInfo.type != '0'"
            class="btn-tast btn-next-1"
            @click="goto_lesson"
          >
            <img src="../../../static/images/icon-back-1.png" alt="" />
            <span class="text_tast_answer">{{ $t("common.returnButton") }}</span>
          </button>
          <!-- == 0 -->
          <button
            v-if="outlineInfo.type == '0'"
            class="btn-tast btn-next-1"
            @click="handleReturn"
          >
            <img src="../../../static/images/icon-back-1.png" alt="" />
            <span class="text_tast_answer">{{ $t("common.returnButton") }}</span>
          </button>

          <!-- <button v-if="outlineInfo.type == '0'" class="submitButton_d btn-tast" @click="handleReturn">
          <img src="../../../static/images/icon2.png" alt="" />
          {{$t('new.title31')}}
          </button> -->
          <button
            v-if="outlineInfo.type == '0'"
            class="btn-tast btn-z-index"
            @click="handleClose"
          >
            <img src="../../../static/images/icon-cb.png" alt="" />
            <span class="text_tast_answer text_tast_answer_cb">{{ $t("task_answer.answerCommit") }}</span>
          </button>
          <button
            v-if="outlineInfo.type != '0'"
            class="btn-tast btn-z-index"
            @click="handleClose"
          >
            <img src="../../../static/images/icon-cb.png" alt=""  />
            <span class="text_tast_answer text_tast_answer_cb">{{ $t("task_answer.answerCommit") }}</span>
          </button>
          <!-- DAP AN -->
          <button v-if="showAnswer == 1 && isCheckClick" class="btn-tast btn-z-index" @click="buttonAnswer()">
            <img src="../../../static/images/IC-dapan2-xanh.png"/>
            <span class="text_tast_answer">{{ $t("task_answer.answer") }}</span>
          </button>
          <!-- <button v-else-if="showAnswer == 1 && !isCheckClick" class="btn-tast btn-z-index disabled_answer_questions">
            <img src="../../../static/images/IC-dapan2-xanh.png"/>
            {{ $t("task_answer.answer") }}
          </button> -->
          <button v-else class="btn-tast btn-z-index disabled_answer_questions" style="color:#000!important">
            <img src="../../../static/images/IC-dapan2-den.png"/>
            <span class="text_tast_answer">{{ $t("task_answer.answer") }}</span>
          </button>
          <!-- DAP AN -->
          <template v-if="questions!=null&&currentQuestionInfo.questionNum==1">
						<button
							style="cursor: no-drop;"
							class="btn-tast"
						>
							<img src="../../../static/images/back-den.png" alt="" />
							<span class="text_tast_answer" style="color: black">{{$t('task_result.prev')}}</span>
						</button>
					</template>
					<template v-else>
						<button
							class="btn-tast"
							@click="changeQuestion(currentQuestionInfo.questionNum -1)"
						>
							<img src="../../../static/images/icon-back.png" alt="" />
							<span class="text_tast_answer">{{$t('task_result.prev')}}</span>
						</button>
					</template>
          <template v-if="questions!=null&&currentQuestionInfo.questionNum==this.questions.length">
						<button
							style="cursor: no-drop;"
							class="btn-tast xoay"
						>
							<img src="../../../static/images/back-den.png" alt="" />
							<span class="text_tast_answer" style="color: black">{{$t('task_result.next')}}</span>
						</button>
					</template>
					<template v-else>
						<button
							class="btn-tast xoay"
							@click="changeQuestion(currentQuestionInfo.questionNum + 1)"
						>
							<img src="../../../static/images/icon-back.png" alt="" />
							<span class="text_tast_answer">{{$t('task_result.next')}}</span>
						</button>
					</template>
        </div>
        <div class="taskPage_task taskPage_task_edit">
          <div class="taskContent_main">
            <!-- <p
            v-if="currentQuestionInfo.questionTypeId=='4'"
            class="answer_note"
          >{{$t('errorBook.select')}}</p> -->
            <div class="task-flex">
              <div class="task_content">
                <!--<p v-if="type!='tast_edit'">-->
                <div
                  class="fix-img-h"
                  v-html="currentQuestionInfo.questionContent"
                >
                  <!--1.设置layout，表示需要显示的内容，用逗号分隔，布局元素会依次显示。prev表示上一页，next为下一页，pager表示页码列表，除此以外还提供了jumper和total，size和特殊的布局符号->，->后的元素会靠右显示，jumper表示跳页元素，total表示总条目数，size用于设置每页显示的页码数量。-->
                </div>
                <audio
                  v-if="
                    currentQuestionInfo.audioName != undefined &&
                    currentQuestionInfo.audioName != null &&
                    currentQuestionInfo.audioName != '' &&
                    'mp3' ==
                      currentQuestionInfo.audioName.substring(
                        currentQuestionInfo.audioName.lastIndexOf('.') + 1
                      )
                  "
                  controls="controls"
                  :src="currentQuestionInfo.audioPath"
                  controlslist="nodownload"
                  oncontextmenu=" return false"
                  class="audio"
                ></audio>
                <video
                  v-if="
                    currentQuestionInfo.audioName != undefined &&
                    currentQuestionInfo.audioName != null &&
                    currentQuestionInfo.audioName != '' &&
                    'mp4' ==
                      currentQuestionInfo.audioName.substring(
                        currentQuestionInfo.audioName.lastIndexOf('.') + 1
                      )
                  "
                  :src="currentQuestionInfo.audioPath"
                  controls="controls"
                  class="video"
                  controlsList="nodownload"
                ></video>
              </div>
              <div
                class="tast-right"
                v-if="currentQuestionInfo.questionTypeId == '1'"
              >
                <div class="task_answer_radio">
                  <p v-if="currentQuestionInfo.optionA">
                    <input
                      v-model="radioValue"
                      id="radio_a"
                      type="radio"
                      name="radio"
                      value="A"
                      @change="checkClick()"
                    />
                    <label for="radio_a">
                      <span class="left_span">A.&nbsp;</span>
                      <span
                        class="right_span"
                        v-html="currentQuestionInfo.optionA"
                      ></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionB">
                    <input
                      v-model="radioValue"
                      id="radio_b"
                      type="radio"
                      name="radio"
                      value="B"
                      @change="checkClick()"
                    />
                    <label for="radio_b">
                      <span class="left_span">B.&nbsp;</span>
                      <span
                        class="right_span"
                        v-html="currentQuestionInfo.optionB"
                      ></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionC">
                    <input
                      v-model="radioValue"
                      id="radio_c"
                      type="radio"
                      name="radio"
                      value="C"
                      @change="checkClick()"
                    />
                    <label for="radio_c">
                      <span class="left_span">C.&nbsp;</span>
                      <span
                        class="right_span"
                        v-html="currentQuestionInfo.optionC"
                      ></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionD">
                    <input
                      v-model="radioValue"
                      id="radio_d"
                      type="radio"
                      name="radio"
                      value="D"
                      @change="checkClick()"
                    />
                    <label for="radio_d">
                      <span class="left_span">D.&nbsp;</span>
                      <span
                        class="right_span"
                        v-html="currentQuestionInfo.optionD"
                      ></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionE">
                    <input
                      v-model="radioValue"
                      id="radio_e"
                      type="radio"
                      name="radio"
                      value="E"
                      @change="checkClick()"
                    />E.&nbsp;
                    <label for="radio_e">
                      <span class="left_span">E.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionE"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionF">
                    <input
                      v-model="radioValue"
                      id="radio_f"
                      type="radio"
                      name="radio"
                      value="F"
                      @change="checkClick()"
                    />F.&nbsp;
                    <label for="radio_f">
                      <span class="left_span">F.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionF"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionG">
                    <input
                      v-model="radioValue"
                      id="radio_g"
                      type="radio"
                      name="radio"
                      value="G"
                      @change="checkClick()"
                    />G.&nbsp;
                    <label for="radio_g">
                      <span class="left_span">G.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionG"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionH">
                    <input
                      v-model="radioValue"
                      id="radio_h"
                      type="radio"
                      name="radio"
                      value="H"
                      @change="checkClick()"
                    />H.&nbsp;
                    <label for="radio_h">
                      <span class="left_span">H.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionH"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionI">
                    <input
                      v-model="radioValue"
                      id="radio_i"
                      type="radio"
                      name="radio"
                      value="I"
                      @change="checkClick()"
                    />I.&nbsp;
                    <label for="radio_i">
                      <span class="left_span">I.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionI"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionJ">
                    <input
                      v-model="radioValue"
                      id="radio_j"
                      type="radio"
                      name="radio"
                      value="J"
                      @change="checkClick()"
                    />J.&nbsp;
                    <label for="radio_j">
                      <span class="left_span">J.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionJ"></span>
                    </label>
                  </p>
                </div>
              </div>
              <div
                class="tast-right"
                v-if="currentQuestionInfo.questionTypeId == '2'"
              >
                <div class="task_answer_radio task_answer_checkbox">
                  <p v-if="currentQuestionInfo.optionA">
                    <input
                      class="ip-check"
                      v-model="checkedValue"
                      id="checkbox_a"
                      type="checkbox"
                      value="A"
                      @change="checkClick()"
                    />
                    <label for="checkbox_a">
                      <span class="left_span">A.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionA"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionB">
                    <input
                      class="ip-check"
                      v-model="checkedValue"
                      id="checkbox_b"
                      type="checkbox"
                      value="B"
                      @change="checkClick()"
                    />
                    <label for="checkbox_b">
                      <span class="left_span">B.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionB"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionC">
                    <input
                      class="ip-check"
                      v-model="checkedValue"
                      id="checkbox_c"
                      type="checkbox"
                      value="C"
                      @change="checkClick()"
                    />
                    <label for="checkbox_c">
                      <span class="left_span">C.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionC"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionD">
                    <input
                      class="ip-check"
                      v-model="checkedValue"
                      id="checkbox_d"
                      type="checkbox"
                      value="D"
                      @change="checkClick()"
                    />
                    <label for="checkbox_d">
                      <span class="left_span">D.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionD"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionE">
                    <input
                      class="ip-check"
                      v-model="checkedValue"
                      id="checkbox_e"
                      type="checkbox"
                      value="E"
                      @change="checkClick()"
                    />
                    <label for="checkbox_e">
                      <span class="left_span">E.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionE"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionF">
                    <input
                      class="ip-check"
                      v-model="checkedValue"
                      id="checkbox_f"
                      type="checkbox"
                      value="F"
                      @change="checkClick()"
                    />
                    <label for="checkbox_f">
                      <span class="left_span">F.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionF"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionG">
                    <input
                      class="ip-check"
                      v-model="checkedValue"
                      id="checkbox_g"
                      type="checkbox"
                      value="G"
                      @change="checkClick()"
                    />
                    <label for="checkbox_g">
                      <span class="left_span">G.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionG"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionH">
                    <input
                      class="ip-check"
                      v-model="checkedValue"
                      id="checkbox_h"
                      type="checkbox"
                      value="H"
                      @change="checkClick()"
                    />
                    <label for="checkbox_h">
                      <span class="left_span">H.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionH"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionI">
                    <input
                      class="ip-check"
                      v-model="checkedValue"
                      id="checkbox_i"
                      type="checkbox"
                      value="I"
                      @change="checkClick()"
                    />
                    <label for="checkbox_i">
                      <span class="left_span">I.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionI"></span>
                    </label>
                  </p>
                  <p v-if="currentQuestionInfo.optionJ">
                    <input
                      class="ip-check"
                      v-model="checkedValue"
                      id="checkbox_j"
                      type="checkbox"
                      value="J"
                      @change="checkClick()"
                    />
                    <label for="checkbox_j">
                      <span class="left_span">J.&nbsp;</span>
                      <span v-html="currentQuestionInfo.optionJ"></span>
                    </label>
                  </p>
                </div>
              </div>
              <div
                class="tast-right tast-chat"
                v-if="
                  currentQuestionInfo.questionTypeId == '3' ||
                  currentQuestionInfo.questionTypeId == '4'
                "
              >
                <div class="task_answer_text">
                  <textarea
                    name
                    :placeholder="$t('errorBook.answerInput')"
                    v-model="textAnswer"
                    @keyup.enter="enterNext($event)"
                    v-on:keyup="checkClick()" 
                  ></textarea>
                </div>
              </div>
              <!-- <quill-editor
            v-model="textAnswer"
            :options="editorOption"
            v-if="currentQuestionInfo.questionTypeId=='4'"
            class="answer tast-right tast-chat"
            @keyup.enter.native="enterNext($event)"
          ></quill-editor> -->
            </div>
            <div class="taskContent_page">
              <el-pagination
                class="task_el_pagination"
                :current-page="currentQuestionInfo.questionNum"
                background
                layout="pager"
                :pageSize="1"
                :total="this.totalNum"
                hide-on-single-page="true"
                @current-change="current_change"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading :showLoading="showLoadingFlg" />
    <!-- dialog -->
    <el-dialog
      class="el_dialog_answer"
      width="30%"
      :visible.sync="isShowModal"
      :modal="true"
      :show-close="true"
    >
      <!-- <div class="dialog_answer_header">
        {{ $t("task_answer.answer") }}
      </div> -->
      <table style="width: 100%; text-align: center;">
        <tr>
          <th style="color: #0071c5 !important;font-size: 15px !important;">{{ $t("errorBook.answer") }}：</th>
          <th style="color: #0071c5 !important;font-size: 15px !important;">{{ $t("errorBook.rightAnswer") }}：</th>
        </tr>
        <tr>
          <td style="font-weight: 500; max-width: 170px;">
            <template v-if="currentQuestionInfo.questionTypeId=='1'">
              <b>{{radioValue}}</b>
            </template>
            <template v-else-if="currentQuestionInfo.questionTypeId=='2'">
              <b>{{valueCheckbox}}</b>
            </template>
            <template v-else>
              {{textAnswer}}
            </template>
          </td>
          <td style="color:#2ba20c; font-weight: 500">
            <template v-if="currentQuestionInfo.questionTypeId=='1'||currentQuestionInfo.questionTypeId=='2'">
              <b>{{answer}}</b>
            </template>
            <template v-else>
              <span v-html="answer"></span>
            </template>
          </td>
        </tr>
      </table>
    </el-dialog>
    <!-- dialog -->
  </div>
</template>

<script>
// import hljs from "highlight.js";
// import "highlight.js/styles/darkula.css";
// import "quill/dist/quill.snow.css";
//国际化引入
import Vue from "vue";
import loading from "@/components/loading/loading";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;
export default {
  name: "schedule_task_answer",
  components: {
    loading,
  },
  data() {
    return {
      showAnswer: 0,
      isShowModal: false,
      isCheckClick: false,
      answer: null,
      showLoadingFlg: false,
      endFlag: 0, //最后一个章节标识
      userId: null, //用户id
      currentQuestionInfo: {
        questionTypeId: 0,
      },
      homeWorkName: "",
      questions: [],
      outlineInfo: {},
      type: "radio", //1.radio:单选,2.checkbox:多选,3.text:填空,4.tast_edit:编程界面
      textAnswer: null, //填空题答案
      totalNum: null, // 总题数
      checkedValue: [], //复选框选中
      radioValue: null, //单选选中
      spendTime: 0, //作业用时
      content: null,
      // editorOption: {
      //   modules: {
      //     syntax: {
      //       highlight: (text) => hljs.highlightAuto(text).value,
      //     },
      //     toolbar: [["code-block"]],
      //     // 						toolbar: {
      //     // 							container: "*选中代码区域，点击此按钮，形成代码编写风格样式",
      //     // 						}
      //   },
      //   theme: "snow",
      //   // placeholder: window.vm.$i18n.t("js.placeholder"),
      // },
      numPagePresent: 1,
      valueCheckbox: ''
    };
  },
  mounted() {
    //获取设备屏幕的高度
    const h = document.body.clientHeight;
    // this.$refs.middle_page.style.minHeight = h + "px";

    this.$autoLogin().then(
      () => {
        this.showLoadingFlg = true;
        this.userId = window.sessionStorage.getItem("id");
        //接收参数
        this.outlineInfo = eval("(" + this.$route.query.outlineInfo + ")");
        //获取习题内容
        this.$api
          .post("/studyCourseQuestion/getScheduleHomeworkQuestionsByCourseOutLineId", {
            courseOutlineId: this.outlineInfo.courseOutlineId,
            languageType: this.$lang(),
          })
          .then((response) => {
            this.showAnswer = response.data.showAnswer;
            this.questions = response.data.questions;
            //页码类型转化，适应分页插件
            this.questions.forEach(function (obj) {
              obj.questionNum = parseInt(obj.questionNum);
            });
            this.currentQuestionInfo = this.questions[0];
            this.checkClick();
            this.totalNum = response.data.questions.length;
            this.showLoadingFlg = false;
          });

        //计时
        let count = setInterval(() => {
          this.spendTime += 1;
        }, 1000);

        //离开页面清除计时方法
        this.$once("hook:beforeDestroy", () => {
          clearInterval(count);
        });
      },
      () => {
        //未登录跳回首页
        this.$router.push({
          path: "/home",
        });
      }
    );
  },
  methods: {
    checkClick() {
      if(this.currentQuestionInfo.questionTypeId=='1') {
        if(this.radioValue!=null) {
          this.isCheckClick = true;
        }
      } else if(this.currentQuestionInfo.questionTypeId=='2'){
        if(this.checkedValue.length>0) {
          this.valueCheckbox = this.checkedValue.toString();
          this.isCheckClick = true;
        } else {
          this.isCheckClick = false;
        }
      } else {
        if(this.textAnswer!=null&&this.textAnswer!="") {
          this.isCheckClick = true;
        } else {
          this.isCheckClick = false;
        }
      }
    },
    buttonAnswer() {
      this.isShowModal = true;
      if(this.currentQuestionInfo.questionTypeId=='3') {
        this.answer = $(this.currentQuestionInfo.questionAnswer).text();
      } else {
        this.answer = this.currentQuestionInfo.questionAnswer;
      }
    },
    enterNext: function (event) {
      if (!(event.shiftKey === true && event.key === "Enter")) {
        if (this.questions.length != this.numPagePresent) {
          this.changeQuestion(this.numPagePresent + 1);
        }
      }
    },
    current_change: function (val) {
      this.changeQuestion(val);
    },
    saveAnswer: function () {
      let saveNum = parseInt(this.currentQuestionInfo.questionNum) - 1;
      if (this.questions[saveNum].questionTypeId == "1") {
        this.questions[saveNum].commitAnswer = this.radioValue;
      } else if (this.questions[saveNum].questionTypeId == "2") {
        this.checkedValue.sort();
        this.questions[saveNum].commitAnswer =
          this.checkedValue.length == 0 ? null : this.checkedValue;
      } else {
        this.questions[saveNum].commitAnswer = this.textAnswer;
      }
    },
    changeQuestion: function (questionNum) {
      if (
        parseInt(questionNum) > this.questions.length &&
        this.outlineInfo.type == "0"
      ) {
        this.$confirm(
          window.vm.$i18n.t("new.title32"),
          window.vm.$i18n.t("js.hint"),
          {
            confirmButtonText: window.vm.$i18n.t("js.confirm"),
            cancelButtonText: window.vm.$i18n.t("js.cancel"),
            cancelButtonClass: "btn-custom-cancel",
          }
        )
          .then(() => {
            if (this.outlineInfo.endFlag == 1) {
              let outlineInfo = {
                courseId: this.outlineInfo.courseId,
                courseName: this.outlineInfo.courseName,
              };
              this.$router.push({
                path: "/home/schedule/schedule_curriculum",
                query: {
                  outlineInfo: JSON.stringify(outlineInfo),
                },
              });
            } else {
              let outlineInfo = {
                topId: this.outlineInfo.nextL1,
                secondId: this.outlineInfo.nextL2,
                thirdId: this.outlineInfo.nextL3,
                fourthId: this.outlineInfo.nextL4,
                fifthId: this.outlineInfo.nextL5,
                type: "Start",
                level: this.outlineInfo.nextLevel,
                courseId: this.outlineInfo.courseId,
                courseName: this.outlineInfo.courseName,
                secondChapterName: this.outlineInfo.nextLevelName,
              };
              this.$router.push({
                path: "/home/curriculum/lesson",
                query: {
                  outlineInfo: JSON.stringify(outlineInfo),
                },
              });
            }
          })
          .catch(() => {});
        return;
      }
      if (parseInt(questionNum) <= 0 && this.outlineInfo.type == "0") {
        let outlineInfo = {
          topId: this.outlineInfo.topId,
          secondId: this.outlineInfo.secondId,
          thirdId: this.outlineInfo.thirdId,
          fourthId: this.outlineInfo.fourthId,
          fifthId: this.outlineInfo.fifthId,
          type: "end",
          level: this.outlineInfo.level,
          courseId: this.outlineInfo.courseId,
          courseName: this.outlineInfo.courseName,
          secondChapterName: this.outlineInfo.secondChapterName,
        };
        this.$router.push({
          path: "/home/curriculum/lesson",
          query: {
            outlineInfo: JSON.stringify(outlineInfo),
          },
        });
        return;
      }
      //保存答案
      this.saveAnswer();
      //清除页面答案
      this.textAnswer = null;
      this.radioValue = null;
      this.checkedValue = [];
      this.numPagePresent = questionNum;
      //切换问题
      this.currentQuestionInfo = this.questions[questionNum - 1];
      //答案赋值
      if (this.currentQuestionInfo.questionTypeId == "1") {
        this.radioValue = this.currentQuestionInfo.commitAnswer;
      } else if (this.currentQuestionInfo.questionTypeId == "2") {
        this.currentQuestionInfo.commitAnswer == null
          ? (this.checkedValue = [])
          : (this.checkedValue = this.currentQuestionInfo.commitAnswer);
      } else {
        this.textAnswer = this.currentQuestionInfo.commitAnswer;
      }
      this.isCheckClick = false;
      this.checkClick();
    },
    commitHomework() {
      let answers = [];
      this.questions.forEach(function (obj) {
        if (obj.questionTypeId == 2 && obj.commitAnswer != null) {
          let answer = obj.commitAnswer[0];
          for (let i = 1; i < obj.commitAnswer.length; i++) {
            answer += "," + obj.commitAnswer[i];
          }
          obj.commitAnswer = answer;
        }
        let objective = {
          questionNum: obj.questionNum,
          commitAnswer: obj.commitAnswer,
          questionTypeId: obj.questionTypeId,
          questionAnswer: obj.questionAnswer,
          questionId: obj.questionId,
          questionScore: obj.questionScore,
        };
        answers.push(objective);
      });

      let param = {
        courseOutlineId: this.outlineInfo.courseOutlineId,
        spendTime: this.s_to_ms(this.spendTime),
        answers: answers,
      };
      this.$api.post("/studyCourseQuestion/commitScheduleHomework", param).then(() => {
        this.$el_alert_type(
          window.vm.$i18n.t("js.submitSuccessTask"),
          "success"
        );
        if (this.outlineInfo.type == "0") {
          if (this.outlineInfo.endFlag == 1) {
            let outlineInfo = {
              courseId: this.outlineInfo.courseId,
              courseName: this.outlineInfo.courseName,
            };
            this.$router.push({
              path: "/home/schedule/schedule_curriculum",
              query: {
                outlineInfo: JSON.stringify(outlineInfo),
              },
            });
          } else {
            let outlineInfo = {
              secondId: this.outlineInfo.secondId,
              thirdId: this.outlineInfo.thirdId,
              fourthId: this.outlineInfo.fourthId,
              fifthId: this.outlineInfo.fifthId,
              type: "Start",
              level: this.outlineInfo.level,
              courseId: this.outlineInfo.courseId,
              courseName: this.outlineInfo.courseName,
              secondChapterName: this.outlineInfo.topId,
              courseOutlineId: this.outlineInfo.secondChapterName,
              activeID: this.outlineInfo.courseOutlineId,
              activeMenu: this.outlineInfo.topId,
            };
            this.$router.push({
              path: "/home/scheduleLesson",
              query: {
                outlineInfo: JSON.stringify(outlineInfo),
              },
            });
          }
        } else {
          //跳转回课程大纲页面
          this.$router.push({
            path: "/home/schedule/schedule_curriculum",
            query: {
              outlineInfo: JSON.stringify(this.outlineInfo),
            },
          });
        }
      });
    },
    goto_lesson: function () {
      let outlineInfo = {
        courseId: this.outlineInfo.courseId,
        courseName: this.outlineInfo.courseName,
      };
      this.$router.push({
        path: "/home/schedule/schedule_curriculum",
        query: {
          outlineInfo: JSON.stringify(outlineInfo),
        },
      });
    },
    s_to_ms: function (s) {
      let m;
      m = Math.floor(s / 60);
      s = s % 60;
      return m == 0 ? s + "s" : m + "min" + s + "s";
    },
    handleClose: function () {
      //保存答案
      this.saveAnswer();
      var n = 0;
      this.questions.forEach(function (obj) {
        if (obj.questionTypeId == 2 && obj.commitAnswer != null) {
          let answer = obj.commitAnswer[0];
          if (answer == undefined || answer == null || answer == "") {
            n = 1;
          }
        } else if (obj.questionTypeId != 2 && obj.commitAnswer != null) {
          let answer = obj.commitAnswer;
          if (answer == undefined || answer == null || answer == "") {
            n = 1;
          }
        } else {
          n = 1;
        }
      });

      if (n == 0) {
        this.$confirm(
          window.vm.$i18n.t("js.submitConfirm"),
          window.vm.$i18n.t("js.hint"),
          {
            confirmButtonText: window.vm.$i18n.t("js.confirm"),
            cancelButtonText: window.vm.$i18n.t("js.cancel"),
            cancelButtonClass: "btn-custom-cancel",
          }
        )
          .then(() => {
            this.commitHomework();
          })
          .catch(() => {});
      } else {
        this.$confirm(
          window.vm.$i18n.t("new.title42"),
          window.vm.$i18n.t("js.hint"),
          {
            confirmButtonText: window.vm.$i18n.t("js.confirm"),
            cancelButtonText: window.vm.$i18n.t("js.cancel"),
            cancelButtonClass: "btn-custom-cancel",
          }
        )
          .then(() => {
            this.commitHomework();
          })
          .catch(() => {});
      }
    },
    handleReturn: function () {
      // this.$confirm(
      //   window.vm.$i18n.t("new.title32"),
      //   window.vm.$i18n.t("js.hint"),
      //   {
      //     confirmButtonText: window.vm.$i18n.t("js.confirm"),
      //     cancelButtonText: window.vm.$i18n.t("js.cancel"),
      //     cancelButtonClass: "btn-custom-cancel"
      //   }
      // ).then(() => {
      if (this.outlineInfo.endFlag == 1) {
        let outlineInfo = {
          courseId: this.outlineInfo.courseId,
          courseName: this.outlineInfo.courseName,
        };
        this.$router.push({
          path: "/home/schedule/schedule_curriculum",
          query: {
            outlineInfo: JSON.stringify(outlineInfo),
          },
        });
      } else {
        let outlineInfo = {
          secondId: this.outlineInfo.secondId,
          thirdId: this.outlineInfo.thirdId,
          fourthId: this.outlineInfo.fourthId,
          fifthId: this.outlineInfo.fifthId,
          type: "Start",
          level: this.outlineInfo.level,
          courseId: this.outlineInfo.courseId,
          courseName: this.outlineInfo.courseName,
          secondChapterName: this.outlineInfo.topId,
          courseOutlineId: this.outlineInfo.secondChapterName,
          activeID: this.outlineInfo.courseOutlineId,
          activeMenu: this.outlineInfo.topId,
        };
        this.$router.push({
          path: "/home/scheduleLesson",
          query: {
            outlineInfo: JSON.stringify(outlineInfo),
          },
        });
      }
      // })
      // .catch(() => {});
    },
  },
};
</script>

<style scoped="scoped">
.task_page {
  width: 100%;
  min-width: 480px;
  background-color: rgb(100, 101, 112);
  background: url(../../../static/images/bg/personset_bg.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  position: relative;
}

.task_main {
  background-color: rgba(65, 65, 65, 0.5);
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
  min-height: calc(100vh - 50px);
}

.taskPage {
  /*min-width: 1200px;*/
  width: 80%;
  margin: 0 auto;
  padding-top: 60px;
  padding-bottom: 50px;
  position: relative;
}

.task_answer_span {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.taskPage_top {
  margin-top: 60px;
}

.taskPage_top p {
  width: calc(60% + 80px);
  /* height: 30px; */
  line-height: 30px;
  margin: 0 auto;
  color: #e8e6e6;
  font-size: 30px;
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
}

.taskPage_top p:last-child {
  font-size: 20px;
}

.taskPage_task_b {
  min-width: 600px;
  width: 60%;
  margin: 0 auto;
  padding-bottom: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 0px 0px 20px 20px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  min-height: 50px;
  position: relative;
}

.taskPage_task {
  min-width: 600px;
  width: 60%;
  margin: 0 auto;
  margin-top: 40px;
  /*padding: 0 20px;*/
  padding-bottom: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 20px 20px 0px 0px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
}

.taskPage_task .task_top {
  height: 40px;
  line-height: 40px;
}

.task_btn {
  height: 25px;
  line-height: 25px;
  width: 60px;
  margin: 10px 0 0 20px;
  background-color: unset;
  font-size: 12px;
  color: rgb(232, 230, 230);
  font-weight: 200;
  border: 1px #fff solid;
  transition: 0.5s ease;
  border-radius: 12.5px;
}

.task_btn:hover {
  background-color: #fff;
  color: #000;
  transition: 0.5s ease;
}

.previous_task {
  position: relative;
  float: left;
  cursor: pointer;
}

.next_task {
  position: relative;
  float: right;
  margin-top: -40px;
  cursor: pointer;
}

.taskContent_page {
  width: 80%;
  height: 40px;
  position: relative;
  margin: 0 auto;
}

.taskContent_main {
  margin-top: 20px;
  padding: 0 100px;
  font-size: 14px;
  /* color: #e8e6e6; */
  text-align: left;
  /*height: 270px;*/
  word-wrap: break-word;
  /* word-break: break-all; */
}

.taskContent_main .task_content {
  line-height: 20px;
  font-size: 14px;
  /* color: #e8e6e6; */
  /* text-align: left; */
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
  text-align: justify;
}

.taskContent_main .task_content p {
  width: 100%;
}

.taskContent_main .answer_note {
  margin-bottom: 10px;
  color: #ff5252;
  font-size: 12px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.task_answer_radio {
  /*min-width: 450px;*/
  /*width: cacl(60% - 50px);*/
  margin-top: 20px;
  /*margin-left: 20px;*/
}

.task_answer_radio p {
  width: calc(100% - 40px);
  line-height: 20px;
  font-size: 14px;
  color: #e8e6e6;
  /* text-align: left; */
  /*margin-left: 20px;*/
  margin-top: 15px;
  /* display: inline-flex; */
  display: -webkit-box;
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
  text-align: justify;
}

.task_answer_radio p label {
  display: -webkit-box;
}

.task_answer_radio p span {
  cursor: pointer;
}

.task_answer_radio input {
  height: 13px;
  margin-right: 10px;
  margin-top: 5px;
}

.task_answer_text {
  margin-top: 20px;
  width: calc(100% - 40px);
  padding: 2px;
  padding-left: 3px;
  padding-right: 3px;
  background-color: #585858;
  border-radius: 20px;
}
.task_answer_text:focus {
  border: 1px #ff5252 solid !important;
}

.task_answer_text textarea {
  margin-top: 2px;
  margin-right: 1px;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  height: 160px;
  line-height: 20px;
  background-color: #fff;
  border-radius: 20px;
  /* background:url("../../../static/images/manual_zh_10.png") no-repeat; */
  font-size: 14px;
  color: #0f0f0f;
  text-align: left;
  border: 0;
  outline: none;
  padding-left: 8px;
  padding-right: 8px;
  /* resize: none; */
}
.task_answer_text textarea:focus {
  /* border: 0 !important;
  background: #585858; */
  color: #363030;
}
.primarylists .titles .title {
  text-transform: none!important;
}
.task_answer_text textarea::-webkit-input-placeholder {
  color: #e8e6e6;
}

.task_answer_text textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #e8e6e6;
}

.task_answer_text textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #e8e6e6;
}

.task_answer_text textarea:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #e8e6e6;
}
.submitButton_d {
  line-height: 20px;
  padding: 4px 12px 5px 12px;
  font-size: 12px;
  color: #fff;
  background-color: unset;
  border-radius: 20px;
  border: 1px #fff solid;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
  position: absolute;
  left: 40%;
  bottom: 30px;
  transform: translate(-50%, 0);
}
.submitButton:hover {
  color: #414141;
  background-color: #fff;
  transition: 0.5s ease;
}
.submitButton_c {
  line-height: 20px;
  padding: 4px 12px 5px 12px;
  font-size: 12px;
  color: #fff;
  background-color: unset;
  border-radius: 20px;
  border: 1px #fff solid;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
  position: absolute;
  left: 60%;
  bottom: 30px;
  transform: translate(-50%, 0);
}
.submitButton_c:hover {
  color: #414141;
  background-color: #fff;
  transition: 0.5s ease;
}
.submitButton {
  line-height: 20px;
  padding: 4px 12px 5px 12px;
  font-size: 12px;
  color: #fff;
  background-color: unset;
  border-radius: 20px;
  border: 1px #fff solid;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translate(-50%, 0);
}
.submitButton:hover {
  color: #414141;
  background-color: #fff;
  transition: 0.5s ease;
}
.prev_btn {
  left: calc(30% - 100px);
  bottom: 30px;
}
.next_btn {
  left: calc(70% + 100px);
  bottom: 30px;
}
.task_post .el-dialog {
  background-color: #585858;
}
.taskPage_task_edit {
  /*width: 100%;*/
  min-height: 500px;
  position: relative;
}

.taskPage_task_edit .taskContent_page {
  /*margin-left: 272px;*/
}
.commit_dialog {
  background-color: #585858;
}
.right_span {
  float: right;
}

@media screen and (max-width: 1024px) {
  .taskPage {
    width: 94%;
    /*min-width: 500px;*/
    padding: 3%;
  }
  .taskPage_task_edit {
    width: 94%;
    margin: 0 3%;
    min-width: unset;
  }
  .taskPage_task_b {
    width: 94%;
    margin: 0 3%;
    min-width: unset;
  }
  .taskContent_main {
    padding: 0 50px;
  }
  .el_dialog_answer{
    width: 96%!important;
    margin-left: auto!important;
    margin-right: auto!important;
  }
}
.el_dialog_answer {
  z-index: 100001!important;;
}
.dialog_answer_header {
  text-align: center;
  font-size: 18px !important;
  color: #0071c5 !important;
  text-transform: uppercase;
}
.dialog_answer_main {
  margin-top: 25px;
  padding: 10px;
  text-align: center;
  font-size: 15px !important;
  font-weight: bold;
}
.btn-z-index {
  z-index: 89 !important;
}
.disabled_answer_questions {
  cursor: no-drop;
}
</style>
<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/schedule/schedule_task_answer.vue